"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SelectDeliveryFrequency = require("./SelectDeliveryFrequency");
Object.keys(_SelectDeliveryFrequency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectDeliveryFrequency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SelectDeliveryFrequency[key];
    }
  });
});
//# sourceMappingURL=index.js.map